import './SobreMim.css'

const SobreMim = () => {
    const tecnologias = [
        'React.js',
        'Next.js',
        'TypeScript',
        'JavaScript',
        'Python',
        'Node.js',
        'C#/.NET',
        'SQL',
        'Tailwind CSS',
        'Styled Components',
        'Jest',
        'React Testing Library',
        'Cypress',
        'AWS S3',
        'AWS CloudFront',
        'AWS Lambda',
        'AWS EC2',
        'AWS CodeBuild',
        'GitHub Actions',
        'REST APIs'
    ];

    return (
        <div id="sobremim" className='sobreMim '>
            <h1>Sobre Mim</h1>
            <div className='secaoSobre'>
                <p>
                    Sou engenheiro de software com experiencia em aplicacoes web corporativas de alto impacto, atuando com React, Next.js, TypeScript, APIs, design systems e ambientes cloud. Trabalho desde a construcao de features e componentes reutilizaveis ate troubleshooting de builds, cache/CDN, pipelines e problemas em producao.
                    <br /> <br /> Sou formado em Analise e Desenvolvimento de Sistemas, tecnico em Informatica pelo IFPB e aluno especial em Sistemas Distribuidos na UFCG. Tenho interesse continuo em arquitetura web, qualidade de codigo, automacao e solucoes escalaveis.
                </p>
            </div>
            <p>
                Aqui estao algumas tecnologias que tenho utilizado:
            </p>
            <ul>
                {tecnologias.map((item) => (
                    <li key={item}>{item}</li>
                ))}
            </ul>
        </div>
    )
}

export default SobreMim
